export default __webpack_public_path__ + "static/Propertymark_CMP_Main_Scheme_Certificate_2022-c8ebfd92f79d0c9db7e6f24f3905cb3e.pdf";